import { routes } from "./paths";

export const noSidebarRoutes = [
  routes.issbOnboarding,
  routes.issbOnboardingInviteTeam,  
  routes.esgLandscapeIssbPlanPublic
  // routes.onboardingSourcesUpload
];
